import axios1 from '@/libs/shield.request'

/**
 * 获取本地锁描述
 */
export const get_local_desc = () => {
    return axios1.request({
        url: '/control/slm_ctrl_get_local_description',
        method: 'get'
    })
}

/**
 * 查询所有设备证书链，会包含锁sn, 外壳号， 证书链
 */
export const get_local_device_p7b = () => {
    return axios1.request({
        url: '/ext/getLocalDeviceP7B',
        method: 'get'
    })
}

/**
 * 查询所有设备证书链，会包含锁sn, 外壳号， 证书链
 */
export const slm_ctrl_sign_by_device = (desc, verify_data) => {
    const data = {
        'desc': desc,
        'verify_data': verify_data
    }
    return axios1.request({
        url: '/control/slm_ctrl_sign_by_device',
        data,
        method: 'post'
    })
}